import React from "react";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";

type TitleFormProps = {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  buttonLabel: string;
  buttonColor: "success" | "danger" | "warning" | "info" | "primary";
  onCancel: () => void;
  onAccept: (e: React.MouseEvent) => void;
};

const TitleForm: React.FC<TitleFormProps> = ({
  title,
  setTitle,
  buttonLabel,
  buttonColor,
  onCancel,
  onAccept,
}) => {
  return (
    <div className="flex flex-column align-items-center gap-5 p-5">
      <span className="p-float-label">
        <InputText id="title" value={title} onChange={e => setTitle(e.target.value)} />
        <label htmlFor="title">{T("word.title")}</label>
      </span>
      <div className="flex justify-content-center gap-3">
        <Button label={T("word.cancel")} onClick={onCancel} className="p-button-secondary" />
        <Button label={buttonLabel} onClick={onAccept} className={`p-button-${buttonColor}`} />
      </div>
    </div>
  );
};

export default TitleForm;
